import type { BadgeVariant } from "@design";
import type { JobStatusResponse, WorkerResponse } from "@/api";

export const WORKER_STATES = ["available", "online", "busy", "offline"] as const;
export type WorkerState = (typeof WORKER_STATES)[number];

export function workerState(worker: WorkerResponse): WorkerState {
  if (worker.status === "busy") return "busy";
  if (worker.status === "online") return worker.available ? "available" : "online";
  return "offline";
}

export const WORKER_BADGE: Record<WorkerState, BadgeVariant> = {
  available: "success",
  online: "info",
  busy: "warning",
  offline: "neutral",
};

export const JOB_STATES = ["queued", "claimed", "running", "succeeded", "failed", "cancelled"] as const;
export type JobState = (typeof JOB_STATES)[number];

export const isJobState = (status: string): status is JobState => (JOB_STATES as readonly string[]).includes(status);

export const JOB_BADGE: Record<JobState, BadgeVariant> = {
  queued: "neutral",
  claimed: "info",
  running: "info",
  succeeded: "success",
  failed: "danger",
  cancelled: "neutral",
};

export const isJobActive = (job: JobStatusResponse) =>
  job.status === "queued" || job.status === "claimed" || job.status === "running";

export function workerVersion(worker: WorkerResponse): string | null {
  const version = worker.capabilities.harness_version;
  return typeof version === "string" ? version : null;
}

export function listOf<T>(response: { [key: string]: T[] } | undefined): T[] {
  return response?.data ?? [];
}
